export const ENV = {
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
  VITE_DOMAIN: import.meta.env.VITE_DOMAIN,
  VITE_APIS_MONOLITH_URL: import.meta.env.VITE_APIS_MONOLITH_URL,
  VITE_APIS_WEBSOCKET_URL: import.meta.env.VITE_APIS_WEBSOCKET_URL,
  VITE_APIS_USERS_DOMAIN_URL: import.meta.env.VITE_APIS_USERS_DOMAIN_URL,
  VITE_APIS_BANKING_DOMAIN_URL: import.meta.env.VITE_APIS_BANKING_DOMAIN_URL,
  VITE_APIS_FINTECH_DOMAIN_URL: import.meta.env.VITE_APIS_FINTECH_DOMAIN_URL,
  VITE_APIS_CHORES_DOMAIN_URL: import.meta.env.VITE_APIS_CHORES_DOMAIN_URL,
  VITE_APIS_KYC_DOMAIN_URL: import.meta.env.VITE_APIS_KYC_DOMAIN_URL,
  VITE_APIS_AI_DOMAIN_URL: import.meta.env.VITE_APIS_AI_DOMAIN_URL,
  VITE_RISK_SCRIPT_URL: import.meta.env.VITE_RISK_SCRIPT_URL,
  VITE_RISK_PUBLIC_KEY: import.meta.env.VITE_RISK_PUBLIC_KEY,
  VITE_WEB_VIEW_KEY: import.meta.env.VITE_WEB_VIEW_KEY,
  VITE_DISCORD_SERVER_ID: import.meta.env.VITE_DISCORD_SERVER_ID,
  VITE_GOOGLE_GTM_ID: import.meta.env.VITE_GOOGLE_GTM_ID,
  VITE_SEGMENT_WRITE_KEY: import.meta.env.VITE_SEGMENT_WRITE_KEY,
  VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  VITE_SENTRY_TRACE_SAMPLE_RATE: import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE,
  VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE: import.meta.env
    .VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE,
  VITE_SENTRY_REPLAY_ERROR_SAMPLE_RATE: import.meta.env
    .VITE_SENTRY_REPLAY_ERROR_SAMPLE_RATE,
  VITE_VGS_VAULT_ID: import.meta.env.VITE_VGS_VAULT_ID,
  VITE_VGS_ENVIRONMENT: import.meta.env.VITE_VGS_ENVIRONMENT,
  VITE_FIREBASE_COLLECTION_NAME: import.meta.env.VITE_FIREBASE_COLLECTION_NAME,
  VITE_WAF_REGION: import.meta.env.VITE_WAF_REGION,
  VITE_WAF_IDENTIFIER: import.meta.env.VITE_WAF_IDENTIFIER,
  VITE_WAF_TOKEN: import.meta.env.VITE_WAF_TOKEN,
  VITE_WAF_SKIP_KEY: import.meta.env.VITE_WAF_SKIP_KEY,
  VITE_COGNITO_USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  VITE_COGNITO_USER_POOL_CLIENT_ID: import.meta.env
    .VITE_COGNITO_USER_POOL_CLIENT_ID,
  VITE_SENTRY_DNS: import.meta.env.VITE_SENTRY_DNS,
  VITE_FRESHCHAT_DOMAIN: import.meta.env.VITE_FRESHCHAT_DOMAIN,
  VITE_FRESHCHAT_APP_TOKEN: import.meta.env.VITE_FRESHCHAT_APP_TOKEN,
  VITE_GOOGLE_PLACES_KEY: import.meta.env.VITE_GOOGLE_PLACES_KEY,
  VITE_GOOGLE_GEOCODE_KEY: import.meta.env.VITE_GOOGLE_GEOCODE_KEY,
  VITE_CHECKOUT_PUBLIC_KEY: import.meta.env.VITE_CHECKOUT_PUBLIC_KEY,
  VITE_GOOGLE_ADDRESS_VALIDATION_KEY: import.meta.env
    .VITE_GOOGLE_ADDRESS_VALIDATION_KEY,
  VITE_APIS_AI_BASE_DOMAIN_URL: import.meta.env.VITE_APIS_AI_BASE_DOMAIN_URL,
  SENTRY_ORG: import.meta.env.SENTRY_ORG,
  SENTRY_PROJECT: import.meta.env.SENTRY_PROJECT,
  SENTRY_AUTH_TOKEN: import.meta.env.SENTRY_AUTH_TOKEN,
  SENTRY_AUTH_TOKEN_2: import.meta.env.SENTRY_AUTH_TOKEN_2,
  VITE_SENTRY_ORG: import.meta.env.VITE_SENTRY_ORG,
  VITE_SENTRY_PROJECT: import.meta.env.VITE_SENTRY_PROJECT,
  VITE_SENTRY_AUTH_TOKEN: import.meta.env.VITE_SENTRY_AUTH_TOKEN,
  VITE_SENTRY_AUTH_TOKEN_2: import.meta.env.VITE_SENTRY_AUTH_TOKEN_2,
  VITE_FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
  VITE_FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  VITE_FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  VITE_FIREBASE_MESSAGING_SENDER_ID: import.meta.env
    .VITE_FIREBASE_MESSAGING_SENDER_ID,
  VITE_FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID,
  VITE_FIREBASE_MEASUREMENT_ID: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  VITE_MIXPANEL_TOKEN: import.meta.env.VITE_MIXPANEL_TOKEN,
  VITE_APPLE_TEAM_ID: import.meta.env.VITE_APPLE_TEAM_ID,
  VITE_APPLE_BUNDLE_ID: import.meta.env.VITE_APPLE_BUNDLE_ID,
  VITE_ANDROID_PACKAGE_NAME: import.meta.env.VITE_ANDROID_PACKAGE_NAME,
};
